// source: usergroup/usergroup.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var authz_annotations_pb = require('../authz/annotations_pb.js');
goog.object.extend(proto, authz_annotations_pb);
goog.exportSymbol('proto.usergroup.UpdateUserGroupMembershipsRequest', null, global);
goog.exportSymbol('proto.usergroup.UserGroupID', null, global);
goog.exportSymbol('proto.usergroup.UserGroupRecord', null, global);
goog.exportSymbol('proto.usergroup.UserGroups', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.usergroup.UserGroupRecord = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.usergroup.UserGroupRecord.repeatedFields_, null);
};
goog.inherits(proto.usergroup.UserGroupRecord, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.usergroup.UserGroupRecord.displayName = 'proto.usergroup.UserGroupRecord';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.usergroup.UserGroupID = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.usergroup.UserGroupID, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.usergroup.UserGroupID.displayName = 'proto.usergroup.UserGroupID';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.usergroup.UserGroups = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.usergroup.UserGroups.repeatedFields_, null);
};
goog.inherits(proto.usergroup.UserGroups, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.usergroup.UserGroups.displayName = 'proto.usergroup.UserGroups';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.usergroup.UpdateUserGroupMembershipsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.usergroup.UpdateUserGroupMembershipsRequest.repeatedFields_, null);
};
goog.inherits(proto.usergroup.UpdateUserGroupMembershipsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.usergroup.UpdateUserGroupMembershipsRequest.displayName = 'proto.usergroup.UpdateUserGroupMembershipsRequest';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.usergroup.UserGroupRecord.repeatedFields_ = [4,5,6,7,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.usergroup.UserGroupRecord.prototype.toObject = function(opt_includeInstance) {
  return proto.usergroup.UserGroupRecord.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.usergroup.UserGroupRecord} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usergroup.UserGroupRecord.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    labelIdsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    userIdsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    fullAccessLabelIdsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    readOnlyLabelIdsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    noAccessLabelIdsList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.usergroup.UserGroupRecord}
 */
proto.usergroup.UserGroupRecord.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.usergroup.UserGroupRecord;
  return proto.usergroup.UserGroupRecord.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.usergroup.UserGroupRecord} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.usergroup.UserGroupRecord}
 */
proto.usergroup.UserGroupRecord.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addLabelIds(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addUserIds(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addFullAccessLabelIds(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addReadOnlyLabelIds(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addNoAccessLabelIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.usergroup.UserGroupRecord.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.usergroup.UserGroupRecord.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.usergroup.UserGroupRecord} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usergroup.UserGroupRecord.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLabelIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getUserIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getFullAccessLabelIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getReadOnlyLabelIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getNoAccessLabelIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.usergroup.UserGroupRecord.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.usergroup.UserGroupRecord} returns this
 */
proto.usergroup.UserGroupRecord.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.usergroup.UserGroupRecord.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.usergroup.UserGroupRecord} returns this
 */
proto.usergroup.UserGroupRecord.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.usergroup.UserGroupRecord.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.usergroup.UserGroupRecord} returns this
 */
proto.usergroup.UserGroupRecord.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated string label_ids = 4;
 * @return {!Array<string>}
 */
proto.usergroup.UserGroupRecord.prototype.getLabelIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.usergroup.UserGroupRecord} returns this
 */
proto.usergroup.UserGroupRecord.prototype.setLabelIdsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.usergroup.UserGroupRecord} returns this
 */
proto.usergroup.UserGroupRecord.prototype.addLabelIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.usergroup.UserGroupRecord} returns this
 */
proto.usergroup.UserGroupRecord.prototype.clearLabelIdsList = function() {
  return this.setLabelIdsList([]);
};


/**
 * repeated string user_ids = 5;
 * @return {!Array<string>}
 */
proto.usergroup.UserGroupRecord.prototype.getUserIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.usergroup.UserGroupRecord} returns this
 */
proto.usergroup.UserGroupRecord.prototype.setUserIdsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.usergroup.UserGroupRecord} returns this
 */
proto.usergroup.UserGroupRecord.prototype.addUserIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.usergroup.UserGroupRecord} returns this
 */
proto.usergroup.UserGroupRecord.prototype.clearUserIdsList = function() {
  return this.setUserIdsList([]);
};


/**
 * repeated string full_access_label_ids = 6;
 * @return {!Array<string>}
 */
proto.usergroup.UserGroupRecord.prototype.getFullAccessLabelIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.usergroup.UserGroupRecord} returns this
 */
proto.usergroup.UserGroupRecord.prototype.setFullAccessLabelIdsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.usergroup.UserGroupRecord} returns this
 */
proto.usergroup.UserGroupRecord.prototype.addFullAccessLabelIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.usergroup.UserGroupRecord} returns this
 */
proto.usergroup.UserGroupRecord.prototype.clearFullAccessLabelIdsList = function() {
  return this.setFullAccessLabelIdsList([]);
};


/**
 * repeated string read_only_label_ids = 7;
 * @return {!Array<string>}
 */
proto.usergroup.UserGroupRecord.prototype.getReadOnlyLabelIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.usergroup.UserGroupRecord} returns this
 */
proto.usergroup.UserGroupRecord.prototype.setReadOnlyLabelIdsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.usergroup.UserGroupRecord} returns this
 */
proto.usergroup.UserGroupRecord.prototype.addReadOnlyLabelIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.usergroup.UserGroupRecord} returns this
 */
proto.usergroup.UserGroupRecord.prototype.clearReadOnlyLabelIdsList = function() {
  return this.setReadOnlyLabelIdsList([]);
};


/**
 * repeated string no_access_label_ids = 8;
 * @return {!Array<string>}
 */
proto.usergroup.UserGroupRecord.prototype.getNoAccessLabelIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.usergroup.UserGroupRecord} returns this
 */
proto.usergroup.UserGroupRecord.prototype.setNoAccessLabelIdsList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.usergroup.UserGroupRecord} returns this
 */
proto.usergroup.UserGroupRecord.prototype.addNoAccessLabelIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.usergroup.UserGroupRecord} returns this
 */
proto.usergroup.UserGroupRecord.prototype.clearNoAccessLabelIdsList = function() {
  return this.setNoAccessLabelIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.usergroup.UserGroupID.prototype.toObject = function(opt_includeInstance) {
  return proto.usergroup.UserGroupID.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.usergroup.UserGroupID} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usergroup.UserGroupID.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.usergroup.UserGroupID}
 */
proto.usergroup.UserGroupID.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.usergroup.UserGroupID;
  return proto.usergroup.UserGroupID.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.usergroup.UserGroupID} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.usergroup.UserGroupID}
 */
proto.usergroup.UserGroupID.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.usergroup.UserGroupID.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.usergroup.UserGroupID.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.usergroup.UserGroupID} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usergroup.UserGroupID.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.usergroup.UserGroupID.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.usergroup.UserGroupID} returns this
 */
proto.usergroup.UserGroupID.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.usergroup.UserGroups.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.usergroup.UserGroups.prototype.toObject = function(opt_includeInstance) {
  return proto.usergroup.UserGroups.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.usergroup.UserGroups} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usergroup.UserGroups.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.usergroup.UserGroupRecord.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.usergroup.UserGroups}
 */
proto.usergroup.UserGroups.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.usergroup.UserGroups;
  return proto.usergroup.UserGroups.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.usergroup.UserGroups} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.usergroup.UserGroups}
 */
proto.usergroup.UserGroups.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.usergroup.UserGroupRecord;
      reader.readMessage(value,proto.usergroup.UserGroupRecord.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.usergroup.UserGroups.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.usergroup.UserGroups.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.usergroup.UserGroups} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usergroup.UserGroups.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.usergroup.UserGroupRecord.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UserGroupRecord items = 1;
 * @return {!Array<!proto.usergroup.UserGroupRecord>}
 */
proto.usergroup.UserGroups.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.usergroup.UserGroupRecord>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.usergroup.UserGroupRecord, 1));
};


/**
 * @param {!Array<!proto.usergroup.UserGroupRecord>} value
 * @return {!proto.usergroup.UserGroups} returns this
*/
proto.usergroup.UserGroups.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.usergroup.UserGroupRecord=} opt_value
 * @param {number=} opt_index
 * @return {!proto.usergroup.UserGroupRecord}
 */
proto.usergroup.UserGroups.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.usergroup.UserGroupRecord, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.usergroup.UserGroups} returns this
 */
proto.usergroup.UserGroups.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.usergroup.UpdateUserGroupMembershipsRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.usergroup.UpdateUserGroupMembershipsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.usergroup.UpdateUserGroupMembershipsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.usergroup.UpdateUserGroupMembershipsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usergroup.UpdateUserGroupMembershipsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    groupIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.usergroup.UpdateUserGroupMembershipsRequest}
 */
proto.usergroup.UpdateUserGroupMembershipsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.usergroup.UpdateUserGroupMembershipsRequest;
  return proto.usergroup.UpdateUserGroupMembershipsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.usergroup.UpdateUserGroupMembershipsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.usergroup.UpdateUserGroupMembershipsRequest}
 */
proto.usergroup.UpdateUserGroupMembershipsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addGroupIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.usergroup.UpdateUserGroupMembershipsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.usergroup.UpdateUserGroupMembershipsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.usergroup.UpdateUserGroupMembershipsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.usergroup.UpdateUserGroupMembershipsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGroupIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.usergroup.UpdateUserGroupMembershipsRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.usergroup.UpdateUserGroupMembershipsRequest} returns this
 */
proto.usergroup.UpdateUserGroupMembershipsRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string group_ids = 2;
 * @return {!Array<string>}
 */
proto.usergroup.UpdateUserGroupMembershipsRequest.prototype.getGroupIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.usergroup.UpdateUserGroupMembershipsRequest} returns this
 */
proto.usergroup.UpdateUserGroupMembershipsRequest.prototype.setGroupIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.usergroup.UpdateUserGroupMembershipsRequest} returns this
 */
proto.usergroup.UpdateUserGroupMembershipsRequest.prototype.addGroupIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.usergroup.UpdateUserGroupMembershipsRequest} returns this
 */
proto.usergroup.UpdateUserGroupMembershipsRequest.prototype.clearGroupIdsList = function() {
  return this.setGroupIdsList([]);
};


goog.object.extend(exports, proto.usergroup);
